import AccountTypeComponent from './AccountTypeContainer';

export default AccountTypeComponent;
